<template>
  <div class="row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Management Report'">
        <template v-slot:preview>
          <b-row>
            <b-col lg="3" md="3">
              <b-form-group id="bulan_id_label" label="Bulan :" label-for="bulan_id">
                <b-form-select id="bulan_id" v-model="date.month" :options="month"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="2">
              <b-form-group id="tahun_id_label" label="Tahun :" label-for="tahun_id">
                <b-form-select v-model="filter.tahun" class="mb-3">
                  <b-form-select-option v-for="(year, index) in years" :value="year" :key="index">{{
                    year
                  }}</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="2">
              <b-form-group id="nilai_resiko_id_label" label="Nilai Resiko :" label-for="bulan_id">
                <b-form-input
                  min="1"
                  type="number"
                  class="mb-3"
                  v-model="filter.nilai_resiko"
                  id="nilai_resiko_id"
                  @keydown="portKeydown($event)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" md="2" class="pt-3">
              <b-button class="mt-5" type="button" size="sm" variant="dark" @click="loadData()">
                Filter
              </b-button>
            </b-col>
          </b-row>
          <div>
            <b-tabs content-class="mt-3" fill>
              <b-tab id="tab_data" title="Data Laporan Bulanan" active>
                <b-row>
                  <b-col md="12">
                    <b-table
                      head-variant="dark"
                      bordered
                      :items="items"
                      :fields="fields"
                      :current-page="currentPage"
                      stacked="lg"
                      show-empty
                      responsive
                      hover
                      :no-local-sorting="true"
                      @sort-changed="sortTable"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      @row-clicked="info"
                      :busy="isBusy"
                    >
                      <template #thead-top="">
                        <b-tr>
                          <b-th colspan="1"></b-th>
                          <b-th>
                            <b-form-input
                              id="filter-1"
                              size="sm"
                              @input="loadData"
                              v-model="search.pabrik"
                              type="search"
                              placeholder="Cari Nama Pabrik..."
                            ></b-form-input>
                          </b-th>
                          <b-th>
                            <b-form-input
                              id="filter-1"
                              size="sm"
                              @input="loadData"
                              v-model="search.nama_equipment"
                              type="search"
                              placeholder="Cari Nama Equipment..."
                            ></b-form-input>
                          </b-th>
                          <b-th colspan="4"></b-th>
                        </b-tr>
                      </template>

                      <template #cell(inspection_result)="data">
                        <span v-html="data.item.inspection_result"></span>
                      </template>

                      <template #cell(recomendation)="data">
                        <span v-html="data.item.recomendation"></span>
                      </template>

                      <template #cell(date)="data">
                        {{ momentDate(data.item.date) }}
                      </template>

                      <template #cell(status)="data">
                        <span v-if="data.item.status === null">-</span>
                        <span v-else-if="data.item.status === 'null'">-</span>
                        <span v-else>{{ data.item.status }}</span>
                      </template>

                      <template #cell(actions)="data">
                        <b-dropdown text=". . ." variant="danger" size="sm" no-caret>
                          <b-dropdown-item-button @click="info(data.item, $event.target)">
                            <div class="btn btn-icon btn-clean btn-sm btn-dropdown mr-1">
                              <span class="svg-icon svg-icon-sm svg-icon-success">
                                <i class="flaticon-eye text-success"></i>
                              </span>
                            </div>
                            View
                          </b-dropdown-item-button>
                          <b-dropdown-item-button
                            @click="
                              $router.push(
                                '/equipment_kritis/edit/' + data.item.id_equipment_kritis
                              )
                            "
                          >
                            <div class="btn btn-icon btn-clean btn-sm btn-dropdown mr-1">
                              <span class="svg-icon svg-icon-sm svg-icon-primary">
                                <i class="flaticon2-pen text-primary"></i>
                              </span>
                            </div>
                            Edit
                          </b-dropdown-item-button>
                          <b-dropdown-item-button @click="toDelete(data)">
                            <div class="btn btn-icon btn-clean btn-sm btn-dropdown mr-1">
                              <span class="svg-icon svg-icon-sm svg-icon-danger">
                                <i class="flaticon2-trash text-danger"></i>
                              </span>
                            </div>
                            Delete
                          </b-dropdown-item-button>
                        </b-dropdown>
                      </template>

                      <template #table-busy>
                        <div class="text-center text-info my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                  <b-col md="5">
                    <b-pagination
                      v-model="currentPage"
                      @input="paginate"
                      :total-rows="totalRows"
                      :per-page="10"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                  <b-col md="5">
                    <h4 class="float-right">
                      Showing
                      <span v-if="totalPerPage">1-{{ totalPerPage }}</span>
                      <span v-else>0</span>

                      of {{ totalRows }}
                    </h4>
                  </b-col>
                </b-row>
                <b-row class="ml-1">
                  <b-alert show variant="primary">
                    <div class="pl-2">
                      <h3>Export Excel:</h3>
                      <ul>
                        <li>Filter merujuk berdasarkan tabel diatas.</li>
                        <li>
                          Jika anda tidak melakukan filter pada tabel diatas, maka akan mengekspor
                          semua data.
                        </li>
                      </ul>
                      <export-excel
                        :data="json_data"
                        :fields="json_fields"
                        :name="'Management Report.xls'"
                      >
                        <b-button
                          variant="light"
                          class="text-dark"
                          :disabled="loading"
                          @click="loadDataExport"
                        >
                          <b-spinner small class="ml-auto" v-if="loading"></b-spinner>
                          <span v-else class="svg-icon svg-icon-sm svg-icon-dark">
                            <i class="flaticon-download"></i>
                          </span>
                          Export
                        </b-button>
                      </export-excel>
                    </div>
                  </b-alert>
                </b-row>
              </b-tab>
              <b-tab id="tab_grafik" title="Grafik Laporan Bulanan">
                <b-form-group>
                  <b-button
                    class="mt-5"
                    type="button"
                    size="sm"
                    variant="light"
                    @click="download_chart_resume"
                  >
                    Download Grafik
                  </b-button>
                </b-form-group>
                <ReportManagement
                  :bulan="grafik.bulan"
                  :tahun="grafik.tahun"
                  :nilai_resiko="grafik.nilai_resiko"
                ></ReportManagement>
              </b-tab>
            </b-tabs>
          </div>

          <b-modal id="info-modal" size="lg" title="Detail" ok-only @hide="resetInfoModal">
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Pabrik :</b></b-col>
              <b-col>{{ modalInfo.nama_pabrik }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Equipment :</b></b-col>
              <b-col>{{ modalInfo.nama_equipment }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Hasil Pemeriksaan :</b></b-col>
              <b-col><span v-html="modalInfo.inspection_result"></span></b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Rekomendasi :</b></b-col>
              <b-col><span v-html="modalInfo.recomendation"></span></b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Dokumentasi :</b></b-col>
              <b-carousel
                v-if="modalInfo.image != null"
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  v-for="(img, indeximg) in JSON.parse(modalInfo.image)"
                  :key="indeximg"
                  :img-src="urlStorage + '/images/report/' + img"
                  :text="modalInfo.image_keterangan[indeximg]"
                ></b-carousel-slide>
              </b-carousel>
              <span v-else-if="modalInfo.image == null"> Tidak ada gambar. </span>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Status :</b></b-col>
              <b-col>{{ modalInfo.status }}</b-col>
            </b-row>
          </b-modal>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'
import ReportManagement from '@/components/management_report/chart.vue'

import * as moment from 'moment'
import 'moment/locale/id'

export default {
  data() {
    return {
      sortBy: 'date',
      filter: {
        bulan: null,
        tahun: null,
        nilai_resiko: null,
      },
      grafik: {
        bulan: null,
        tahun: null,
        nilai_resiko: null,
      },
      sortDesc: true,
      sort_label: 'DESC',
      items: [],
      fields: [
        { key: 'date', label: 'Tanggal', sortable: true },
        { key: 'nama_pabrik', label: 'Pabrik', sortable: true },
        { key: 'nama_equipment', label: 'Equipment', sortable: true },
        { key: 'inspection_result', label: 'Hasil Pemeriksaan' },
        { key: 'recomendation', label: 'Rekomendasi' },
        { key: 'status', label: 'Status', sortable: true },
      ],
      date: {
        month: null,
      },
      month: [
        { value: null, text: '-- Pilih Bulan --' },
        { value: '01', text: 'Januari' },
        { value: '02', text: 'Februari' },
        { value: '03', text: 'Maret' },
        { value: '04', text: 'April' },
        { value: '05', text: 'Mei' },
        { value: '06', text: 'Juni' },
        { value: '07', text: 'Juli' },
        { value: '08', text: 'Agustus' },
        { value: '09', text: 'September' },
        { value: '10', text: 'Oktober' },
        { value: '11', text: 'November' },
        { value: '12', text: 'Desember' },
      ],
      pabrikList: [],
      search: {
        pabrik: '',
        nama_equipment: '',
      },
      modalInfo: {
        pabrik: null,
        nama_equipment: null,
      },
      json_fields: {
        No: 'no',
        'Tanggal ': 'tanggal',
        'Nama Pabrik': 'pabrik',
        'Nama Equipment': 'equipment',
        'Hasil Pemeriksaan': 'hasil_pemeriksaan',
        'Hasil Rekomendasi': 'rekomendasi',
        'Status ': 'status',
        'Dokumentasi ': 'image',
      },
      json_data: [],
      totalRows: 0,
      totalPerPage: 0,
      currentPage: 1,

      isBusy: false,
      dialog: false,
      loading: false,
      slide: 0,

      urlStorage: '',
    }
  },
  computed: {
    years() {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 2015 }, (value, index) => 2016 + index)
    },
  },
  components: {
    KTCodePreview,
    ReportManagement,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Management Report', route: '' },
      { title: 'Management Report' },
    ])
  },
  created() {
    const year = new Date().getFullYear()
    this.filter.tahun = year
    this.urlStorage = ApiService.urlStorage()
  },
  methods: {
    portKeydown(e) {
      if (/^\+$/.test(e.key)) {
        e.preventDefault()
      }
    },
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    moment: function (date) {
      moment.locale('id')
      return moment(date).format('DD/MM/YYYY')
    },
    momentDate: function (date) {
      moment.locale('id')
      return moment(date, 'YYYY-MM-DD LTS').format('DD MMM YYYY')
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.loadData()
    },
    ClearDate() {
      this.search.tanggal[0] = ''
      this.search.tanggal[1] = ''
    },
    info(item, button) {
      this.modalInfo.nama_equipment = item.nama_equipment
      this.modalInfo.nama_pabrik = item.nama_pabrik
      this.modalInfo.inspection_result = item.inspection_result
      this.modalInfo.recomendation = item.recomendation
      this.modalInfo.status = item.status
      this.modalInfo.image = item.image
      if (item.image) {
        this.modalInfo.image_keterangan = JSON.parse(item.image_keterangan)
      }
      this.$root.$emit('bv::show::modal', 'info-modal', button)
    },
    resetInfoModal() {
      this.modalInfo.pabrik = null
      this.modalInfo.nama_equipment = null
      this.modalInfo.inspection_result = null
      this.modalInfo.recomendation = null
      this.modalInfo.status = null
      this.modalInfo.image = null
      this.modalInfo.image_keterangan = null
    },
    paginate() {
      this.loadData()
    },
    sortTable() {
      this.sort_label = 'ASC'
      if (this.sortDesc) {
        this.sort_label = 'DESC'
      }
      this.sortDesc = !this.sortDesc
      this.loadData()
    },
    download_chart_resume() {
      if (
        this.grafik.bulan != null &&
        this.grafik.tahun != null &&
        this.grafik.nilai_resiko != null
      ) {
        const image = document.createElement('a')
        const canvas = document.getElementById('report_management')
        image.href = canvas.toDataURL('image/png', 1)
        image.download = 'Chart Management Report.png'
        image.click()
      } else {
        this.makeToast('warning', 'Data Filter Bulan, Tahun dan Nilai Resiko Harus Diisi!')
      }
    },
    async loadData() {
      var self = this
      self.isBusy = true

      if (
        this.filter.tahun !== null &&
        this.date.month !== null &&
        this.filter.nilai_resiko !== null
      ) {
        self.grafik.bulan = this.date.month
        self.grafik.tahun = this.filter.tahun
        self.grafik.nilai_resiko = this.filter.nilai_resiko
        await this.timeout(100)
        ApiService.get(
          '/management_report?page=' +
            this.currentPage +
            '&pabrik=' +
            this.search.pabrik +
            '&nama_equipment=' +
            this.search.nama_equipment +
            '&sortBy=' +
            this.sortBy +
            '&sortDesc=' +
            this.sort_label +
            '&bulan=' +
            this.date.month +
            '&tahun=' +
            this.filter.tahun +
            '&nilai_kritis=' +
            this.filter.nilai_resiko
        )
          .then(({ data }) => {
            if (data.status == 'ok') {
              self.items = data.data.data
              self.totalRows = data.data.total
              self.totalPerPage = data.data.data.length
              self.isBusy = false

              self.loadDataExport()
            }
          })
          .catch((response) => {
            console.log(response)
          })
      } else {
        this.makeToast('Data Filter Bulan, Tahun dan Nilai Resiko Harus Diisi!')
        self.isBusy = false
      }
    },
    async loadDataExport() {
      var self = this
      self.loading = true

      if (this.filter.tahun !== null && this.date.month !== null) {
        await this.timeout(100)
        ApiService.get(
          '/management_report/export?page=' +
            this.currentPage +
            '&pabrik=' +
            this.search.pabrik +
            '&nama_equipment=' +
            this.search.nama_equipment +
            '&bulan=' +
            this.date.month +
            '&tahun=' +
            this.filter.tahun
        )
          .then(({ data }) => {
            if (data.status == 'ok') {
              self.json_data.splice(0, self.json_data.length)
              data.data.forEach((row, index) => {
                var image = ''
                if (row.image !== null) {
                  image =
                    ApiService.urlApi() + '/management_report/downloadImage?id=' + row.id_report
                } else {
                  image = 'Data Tidak Ada'
                }
                self.json_data.push({
                  no: index + 1,
                  tanggal: row.date,
                  pabrik: row.nama_pabrik,
                  equipment: row.nama_equipment,
                  hasil_pemeriksaan: row.inspection_result,
                  rekomendasi: row.recomendation,
                  status: row.status === null || row.status === 'null' ? '-' : row.status,
                  image: image,
                })
              })
              self.loading = false
            }
          })
          .catch((response) => {
            console.log(response)
          })
      } else {
        this.makeToast('Data Filter Bulan, Tahun dan Nilai Resiko Harus Diisi!')
        self.loading = false
      }
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms)
      })
    },
    makeToast(variant = null, $content) {
      this.$bvToast.toast($content, {
        title: `${variant || 'default'}`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true,
      })
    },
    async loadPabrik() {
      var self = this
      self.pabrikList = { id_pabrik: null, nama_pabrik: 'Semua' }
      await ApiService.get('/master/pabrik/get').then(({ data }) => {
        self.pabrikList = [self.pabrikList, ...data.data]
      })
    },
  },
}
</script>
<style>
.mx-datepicker-range {
  width: 200px;
}
</style>
